import { axiosClient } from 'www/utils'
import type {
  ApiDoctorSpecialitiesParamsGet,
  ApiDoctorSpecialitiesResponseGet,
} from 'www/vue_components/common/TheFilters/lpu/api/apiDoctorSpecialities.types'

export default {
  get(params: ApiDoctorSpecialitiesParamsGet) {
    return axiosClient.get<ApiDoctorSpecialitiesResponseGet>('/api/town/specialities-for-lpu/', { params })
  },
}
